import { Routes } from "@angular/router";
import { PitNavigatorComponent } from "./ui/components/pit-navigator/pit-navigator.component";
import { DxAuthGuard } from "../dx-auth/services/dx-auth-guard";
const ɵ0 = () => import("./../bdpk-tasks/bdpk-tasks.module.ngfactory").then(mod => mod.BdpkTasksModuleNgFactory);
const routes = [
    {
        path: 'navigator',
        pathMatch: 'prefix',
        component: PitNavigatorComponent,
        canActivate: [DxAuthGuard],
        children: [
            { path: '', redirectTo: 'tasks', pathMatch: 'full' },
            { path: 'tasks', loadChildren: ɵ0 },
        ]
    },
];
/**
 * Модуль декларирует внутренний роутинг в `PitNavigationModule`.
 *
 * Что какается отложенной загрузки модулей при помощи конструкции:
 * ```
 * loadChildren: '<относительный путь до ts-файла модуля>#<имя класса модуля>'
 * ```
 * Да неудобно, но другого пути нет. Конструкция с лямда выражением:
 * ```
 * loadChildren () => PitHomeModule
 * ```
 * не работает. Заморочки с AOT-компиляцией.
 *
 * Также работает конструкция:
 * ```
 * export function getPitHomeModule(): any { return PitHomeModule; }
 * loadChildren: getPitHomeModule
 * ```
 * Ее и будем использовать, как наболее удобную с точки зрения рефакторинга.
 */
export class PitNavigationRoutingModule {
}
export { ɵ0 };
